function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.345 38L30 35.214 19.311 24 30 12.786 27.345 10 14 24l13.345 14z",
  fill: "#fff"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#00478C"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.953 36.54a1.922 1.922 0 102.783-2.652L19.31 24l9.425-9.888a1.922 1.922 0 00-2.783-2.652L15.112 22.834a1.69 1.69 0 000 2.332L25.953 36.54z",
  fill: "#fff"
});
function SvgTrimFilterCarouselRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      rotate: "180deg"
    }
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default SvgTrimFilterCarouselRight;